import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setCategoryColorOnNewCategory')(function setCategoryColorOnNewCategory(categoryColor) {
    store.newCategory.Color = +categoryColor;
});
//# sourceMappingURL=setCategoryColorOnNewCategory.js.map